import { GET_PRODUCT_REPORT_REQUEST, GET_PRODUCT_REPORT_SUCCES, GET_PRODUCT_REPORT_ERROR } from "../actions/types";

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_PRODUCT_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_PRODUCT_REPORT_SUCCES:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_PRODUCT_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };

        default: {
            return state;
        }
    }
};
